import * as s from "./animation.module.css";

export const animation = {
  flip: s.flip,
  fade: s.fade,
};
